import React from 'react';

// Top banner. Uses the original banner artwork.
function Banner() {
  return (
    <header className="banner">
      <img src="/images/banner2.gif" alt="Olaf Johannsen ApS" />
    </header>
  );
}

export default Banner;
